import React, { useState } from 'react';
import Classes from './Cart.module.css';
import { useNavigate } from 'react-router-dom';

const TableRow = ({ item, onRemove, onQuantityChange, onSizeChange }) => {
    const [selectedSize, setSelectedSize] = useState(item?.selectedSize || '');

    const handleSizeChange = (e) => {
        const newSize = e.target.value;
        setSelectedSize(newSize);
        onSizeChange(item?.id, item?.selectedImage, newSize);
    };

    const handleDecrease = () => {
        if (item?.quantity > 1) {
            onQuantityChange(item?.quantity - 1);
        }
    };

    const handleIncrease = () => {
        onQuantityChange(item?.quantity + 1);
    };

    const navigateTo = useNavigate();

    const handleNavigate = (link) => {
        navigateTo(link);
    }

    return (
        <div className={Classes.tableRow}>
            <div className={`${Classes.tableBodyItem} ${Classes.productCon}`}>
                <div className={Classes.tableBodyItemImg}>
                    <img src={item?.selectedImage} alt={item?.title} draggable={false} onClick={() => { handleNavigate(`/product/${item?.id}`) }} />
                </div>
                <div className={Classes.tableBodyItemDetails}>
                    <h5>{item?.title}</h5>
                    <p>Size:
                        <select
                            value={selectedSize}
                            onChange={handleSizeChange}
                            className={Classes.sizeSelect}
                        >
                            {item?.size?.map(size => (
                                <option key={size} value={size}>
                                    {size}
                                </option>
                            ))}
                        </select>
                    </p>
                </div>
            </div>
            <div className={`${Classes.tableBodyItem} ${Classes.flexBetween}`}>
                <h5>AED {item?.price}</h5>
            </div>
            <div className={`${Classes.tableBodyItem} ${Classes.flexBetween}`}>
                <div className={Classes.flex10}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width='10px'
                        cursor='pointer'
                        fill='#353535'
                        viewBox="0 0 448 512"
                        onClick={handleDecrease}
                    >
                        <path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z" />
                    </svg>
                    <h5>{item?.quantity}</h5>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width='12px'
                        cursor='pointer'
                        fill='#353535'
                        viewBox="0 0 448 512"
                        onClick={handleIncrease}
                    >
                        <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" />
                    </svg>
                </div>
            </div>
            <div className={`${Classes.tableBodyItem} ${Classes.flexEnd}`} style={{ position: 'relative' }} >
                <h5>AED {(item?.price * item?.quantity)}</h5>
                <button
                    className={Classes.removeBtn}
                    type='button'
                    onClick={() => onRemove(item?.id)}
                >
                    <h5> Remove </h5>
                </button>
            </div>
        </div>
    );
};

export default TableRow;